<template>
  <div class="hidden justify-center flex-wrap mx-auto mb-6 lg:flex">
    <div class="w-1/2 pr-12 text-center">
      <div
        class="background-box rounded-3xl image-blog"
        :style="`background-image: url(${item.image}); min-height: 400px;`"
      ></div>
    </div>
    <div class="w-1/2 pl-12 flex justify-center items-center">
      <card-blog :item="item" :show-image="false"></card-blog>
    </div>
  </div>
</template>

<script>
import CardBlog from "./CardBlog.vue";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    CardBlog,
  },
};
</script>

<style>
</style>